import { pbReports } from './adapters/pb-reports'
import type { ReportPort } from './domain/operational-report'

const reports: ReportPort = pbReports

export { reports }
